import {useQuery} from '@tanstack/react-query';

import {useApiClient} from '@/hooks';

import {municipalAuthoritiesApi} from '../api';

export const municipalAuthoritiesKeys = {
  all: () => ['municipal-authorities'] as const
};

export function useMunicipalAuthoritiesQuery(options?: {enabled?: boolean}) {
  const client = useApiClient();
  return useQuery({
    queryKey: municipalAuthoritiesKeys.all(),
    queryFn: () => municipalAuthoritiesApi.fetchMunicipalAuthorities(client),
    enabled: options?.enabled ?? true,
    select: response => response.data,
    staleTime: 60 * 60 * 1000
  });
}
